import React, { useState } from 'react';

import MediaContent from '../../components/Give/MediaContent';
import patreonLogo from '../../images/patreon-logo.svg';
import CustomDonations from './CustomDonations';
import CurrencySwitcher from '../Header/currencyswitcher/CurrencySwitcher';
import { LJCampaignUrl, LJLanguageCampaignUrl } from '../../constants/donorboxcampaign';
import DonorboxForm from '../NewGive/DonorForm';

const Donation = ({
  patreonThumb,
  isStandardCheckOut,
  bgClassName,
  activeState = 1,
  showTab = true,
  isCustomDonation = false,
  projectsLists,
  defaultSelected,
  hideTaxDeductibleTab = false,
}) => {
  const [activeTabId, setActiveTabId] = useState(activeState);
  return (
    <div>
      {showTab && (
        <div className="wrapper wrapper-lg pd-x-md">
          <ul
            className="tab-head give-head method-donation d-flex"
            style={{ justifyContent: hideTaxDeductibleTab ? 'center' : 'flex-start' }}>
            {[
              [1, isStandardCheckOut ? 'Standard Checkout' : 'Online Give'],
              [2, 'Patreon'],
              [3, 'US Tax Deductible'],
              [4, 'Check'],
            ].map((tabItem, index) => {
              if (hideTaxDeductibleTab && index == 2) {
                return null;
              }
              return (
                <li
                  className={`tab-item method-list ${activeTabId === tabItem[0] ? 'active' : ''}`}
                  key={tabItem[0]}
                  onClick={() => {
                    setActiveTabId(tabItem[0]);
                    window.innerWidth < 768 && window.scrollTo({ top: 1100, behavior: 'smooth' });
                  }}>
                  {tabItem[1]}
                </li>
              );
            })}
          </ul>
        </div>
      )}
      <div className="tab-body give-body">
        <div
          className={`section tab-content method-1 ${bgClassName ?? 'bg-light'} ${isCustomDonation ? '' : ' pd-y-0 '} ${activeTabId !== 1 ? 'd-none' : ''
            }`}>
          <div className="method-body d-flex justify-content-center align-items-center">
            {isCustomDonation ? (

              <CustomDonations projectsLists={projectsLists} defaultSelected={defaultSelected} />
            ) : (
              <>
                <script src="https://donorbox.org/widget.js" paypalExpress="false"></script>
                {isStandardCheckOut ? (
                  <iframe
                    src={LJLanguageCampaignUrl}
                    name="donorbox"
                    allowpaymentrequest="allowpaymentrequest"
                    seamless="seamless"
                    frameborder="0"
                    scrolling="no"
                    height="900px"
                    width="100%"
                    style={{
                      maxWidth: '500px',
                      minWidth: '250px',
                      maxHeight: 'none!important',
                    }}></iframe>
                ) : (
                  <DonorboxForm embedCode={LJCampaignUrl} width="100%" />
                )}
              </>
            )}
          </div>
        </div>
        <div
          className={`section tab-content method-2 ${bgClassName ?? 'bg-light'} pd-y-0 ${activeTabId !== 2 ? 'd-none' : ''
            }`}>
          <div className="method-body">
            <div className="method-content">
              <div className="wrapper wrapper-md pd-x-md">
                <div className="wrapper-sm">
                  <img src={patreonLogo} alt="Patreon" className="method-logo" />
                  <p className="p-lg">
                    Join our Patreon Community by supporting on a monthly basis in return for some exciting rewards
                    including: early access to episodes, google hangout calls, Q&A videos, Colourings Books, DVD’s, T
                    Shirts and more!
                  </p>
                  <a
                    href="https://www.patreon.com/lineagejourney"
                    target="_blank"
                    className="btn btn-md btn-primary-ii">
                    Go To Our Patreon Page
                  </a>
                </div>
              </div>
            </div>
            <MediaContent thumbnail={patreonThumb} />
          </div>
        </div>
        <div
          className={`section tab-content method-3 ${bgClassName ?? 'bg-light'} pd-y-0 ${activeTabId !== 3 ? 'd-none' : ''
            }`}>
          <div className="method-body">
            <div className="method-content">
              <div className="wrapper wrapper-md pd-x-md">
                <div className="wrapper-xs">
                  <p className="p-lg">
                    If you live in the US and you want to make a tax deductible donation then follow these 4 steps:
                  </p>
                  <ul className="list-counter">
                    <li>
                      Go to <a href="https://www.outpostcenters.org/donate">www.outpostcenters.org/donate</a>
                    </li>
                    <li>Select Ministry - Lineage Journey - Click continue</li>
                    <li>Fill in the rest of the form with the donation amount and personal details.</li>
                  </ul>
                  <span className="list-note">Note: You can make this a recurring donation also*</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          className={`section tab-content method-3 ${bgClassName ?? 'bg-light'} pd-y-0 ${activeTabId !== 4 ? 'd-none' : ''
            }`}>
          <div className="method-body">
            <div className="method-content">
              <div className="wrapper wrapper-md pd-x-md">
                <div className="wrapper-md">
                  <div className="list-wrap mg-b-30">
                    <p className="header">
                      Should you wish to make a give by check/cheque then please follow these instructions:
                    </p>
                    <ul className="list-counter">
                      <li>Make the check out to ‘Lineage Journey’.</li>
                      <li>
                        Send it to:
                        <br />
                        Lineage Journey
                        <br />
                        PO Box 405
                        <br />
                        Grass Valley
                        <br />
                        CA, 95945
                        <br />
                        USA
                      </li>
                    </ul>
                    <span className="list-note">Note: This donation will also be tax deductible</span>
                  </div>
                  <div className="list-wrap">
                    <p className="header">Or if you don’t live in the US you can follow the instructions below:</p>
                    <ul className="list-counter">
                      <li>Make it out to ‘Lineage Journey’</li>
                      <li>
                        Post it to: <br />
                        Lineage Journey <br />
                        17 Little Meadow
                        <br /> Cotgrave
                        <br /> Nottingham
                        <br /> NG123PN
                        <br /> United Kingdom
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={`section method-footer method-note ${bgClassName ?? 'bg-light'}`}>
        <div className="wrapper wrapper-md pd-x-md">
          <h6 className="note-title">Thank you so much for supporting Lineage Journey!</h6>
          <div className="note-text">
            <p>
              Lineage Journey is a registered non-profit organisation (in the UK) and relies on crowdfunding and the
              generous givings of our supporters to produce high quality videos and resources. With an average giving of
              less than <CurrencySwitcher price={30} isCommaSeparated={true} caller="donation index" />, monthly (Patreon) supporters make our
              work possible through their kindness and generosity. All our videos are available for free, thanks to your
              help.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Donation;
